<template>
    <div>
        <TModal v-model="oldChanges.show">
            <div class="tw-text-xl tw-font-medium tw-leading-6 tw-text-gray-900">
                We've found some previously unsaved work!
            </div>
            <div class="tw-text-gray-900 tw-mt-4">
                <p>
                    These changes may be because:
                </p>
                <p>
                    <ul class='tw-list-disc tw-mt-2 tw-ml-8'>
                        <li>you closed a browser while editing</li>
                        <li>you are still editing on another browser tab</li>
                        <li>you are just refreshing the browser while editing</li>
                    </ul>
                </p>
                <p class='tw-mt-5'>
                    How would you like to proceed?
                </p>
            </div>
            <div class="tw-flex tw-justify-end tw-mt-8">
                <button
                    type="button"
                    class="
                    tw-cursor-pointer
                    tw-bg-blue-600 tw-text-white hover:tw-bg-blue-400
                    tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-transparent
                    tw-px-4 tw-py-2 tw-text-sm tw-font-medium focus:tw-outline-none 
                    focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2"
                    @click="foundOldRestore"
                >
                    Apply changes
                </button>
                <button
                    type="button"
                    class="
                    tw-cursor-pointer
                    tw-text-gray-800 tw-bg-white hover:tw-bg-gray-100 tw-border tw-border-gray-300
                    tw-ml-2 tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-transparent
                    tw-px-4 tw-py-2 tw-text-sm tw-font-medium focus:tw-outline-none 
                    focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2"
                    @click="foundOldRevert"
                >
                    Disregard
                </button>
            </div>
        </TModal>
        <div 
            v-if="!loading && initialized"
            class="tw-p-4 tw-overflow-auto tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center">
            <div class="tw-container">
                <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                    <div class="tw-text-3xl">{{ comm_id ? 'Editing Comm' : 'New Comm' }}</div>
                    <div class="tw-text-lg tw-text-red-500 tw-font-bold tw-bg-red-100 tw-px-2 tw-rounded" v-if="unsavedChanges">Unsaved changes!</div>
                    <div class="tw-p-3 tw-flex tw-items-end">
                        <div v-if="false" class="md:tw-mr-6">
                            <TSwitch v-model="is_dev">
                                <span class="tw-mr-1 tw-text-sm">{{ is_dev ? 'Test mode?' : 'Test mode?' }}</span>
                            </TSwitch>
                        </div>
                        <div>
                            <TSwitch v-model="enabled">
                                <span class="tw-mr-1 tw-text-sm">{{ enabled ? 'Enabled?' : 'Enabled?' }}</span>
                            </TSwitch>
                        </div>
                    </div>
                </div>
                <div class="tw-p-3 tw-flex">
                    <div class="tw-mr-4">
                        <TField label="Type">
                            <TDropdown
                                :columns="1"
                                width="tw-w-auto"
                            >
                                <template #trigger>
                                    <TButton
                                        class="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"

                                    >
                                        <span class="mdi" :class="{email:'mdi-email','in-app':'mdi-inbox-full'}[comm_type]"></span>
                                        <span class="mdi mdi-unfold-more-horizontal tw-ml-2"></span>
                                    </TButton>
                                </template>
                                <template #content>
                                    <a @click="comm_type = 'email';" class="tw-cursor-pointer hover:tw-bg-slate-100 tw-px-2 tw-rounded">
                                        <div class="tw-flex tw-items-center">
                                            <span class="tw-text-3xl mdi mdi-email tw-mr-4"></span>
                                            <div class="media-content">
                                                <h3>Email</h3>
                                            </div>
                                        </div>
                                    </a>
                                    <div @click="comm_type ='in-app'" class="tw-whitespace-nowrap tw-cursor-pointer tw-px-2 hover:tw-bg-slate-100 tw-rounded">
                                        <div class="tw-flex tw-items-center">
                                            <span class="tw-text-3xl mdi mdi-inbox-full tw-mr-4"></span>
                                            <div class="media-content">
                                                <h3>In App Message</h3>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </TDropdown>
                        </TField>
                    </div>
                    <div class="tw-mr-4">
                        <TField label="When">
                            <TDropdown>
                                <template #trigger>
                                    <TButton
                                        class="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                                    >
                                        <span class="mdi" :class="{OneShot:'mdi-numeric-1-box',OnGoing:'mdi-clock',Event:'mdi-gesture-double-tap'}[send_type]"></span>
                                        <span class="mdi mdi-unfold-more-horizontal tw-ml-2"></span>
                                    </TButton>
                                </template>
                                <template #content>
                                    <a @click="send_type = 'OneShot';" class="tw-cursor-pointer hover:tw-bg-slate-100 tw-p-2 tw-rounded">
                                        <div class="tw-flex tw-items-center">
                                            <span class="tw-text-3xl mdi mdi-numeric-1-box tw-mr-4"></span>
                                            <div class="media-content">
                                                <h3>Once</h3>
                                                <small>Recipient list will be determined once. <b>This is most likely what you want.</b></small>
                                            </div>
                                        </div>
                                    </a>
                                    <div @click="send_type ='OnGoing'" class="tw-cursor-pointer hover:tw-bg-slate-100 tw-p-2 tw-rounded">
                                        <div class="tw-flex tw-items-center">
                                            <span class="tw-text-3xl mdi mdi-clock tw-mr-4"></span>
                                            <div class="media-content">
                                                <h3>Live Cohort</h3>
                                                <small>Recipient list will be updated until the campaign ends.</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div @click="send_type ='Event'" class="tw-cursor-pointer hover:tw-bg-slate-100 tw-p-2 tw-rounded">
                                        <div class="tw-flex tw-items-center">
                                            <span class="tw-text-3xl mdi mdi-gesture-double-tap tw-mr-4"></span>
                                            <div class="media-content">
                                                <h3>Triggered</h3>
                                                <small>Receipients will be communicated with via Commsbridge event API.</small>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </TDropdown>
                        </TField>
                    </div>
                    <div class="tw-mr-4 tw-flex-1">
                        <TField label="Name (required)">
                            <TInput required v-model="name"></TInput>
                        </TField>
                    </div>
                    <div class="tw-ml-4">
                        <TField label="Category">
                            <TSimplePicker
                                button-class="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                                v-model="category"
                                :items="[
                                    {
                                        value: 'company_news',
                                        label: 'Company News'
                                    },
                                    {
                                        value: 'roon_software_news',
                                        label: 'Roon Software News'
                                    },
                                    {
                                        value: 'roon_software_promos',
                                        label: 'Roon Software Promos'
                                    },
                                    {
                                        value: 'roon_store_promos',
                                        label: 'Roon Store Promos'
                                    },
                                    {
                                        value: 'roon_mastery',
                                        label: 'Roon Mastery'
                                    },
                                    {
                                        value: 'transactional',
                                        label: 'Transactional'
                                    },
                                ]"
                                :format="val => val.label"
                            >
                            </TSimplePicker>
                        </TField>
                    </div>
                </div>
                <div>
                    <div class="tw-flex">
                        <TSwitch v-model="variable_substitution">
                            <div class="tw-mr-2 tw-font-semibold" style="font-size: 1rem !important;">{{variable_substitution_string}}</div>
                        </TSwitch>
                    </div>
                    <div class="tw-flex">
                        <TSwitch v-model="scheduled">
                            <div class="tw-mr-2 tw-font-semibold" style="font-size: 1rem !important;">Scheduled?</div>
                        </TSwitch>
                    </div>
                    <div v-if="scheduled" class="tw-pl-4">
                        <div class="tw-flex">
                            <TField label="Start at">
                                <TDatetime
                                    v-model="start_date"
                                >
                                </TDatetime>
                            </TField>
                        </div>
                        <div class="tw-flex">
                            <TField label="End at">
                                <TDatetime
                                    v-model="end_date"
                                >
                                </TDatetime>
                            </TField>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="tw-flex">
                        <TSwitch v-model="local_time">
                            <div class="tw-mr-2 tw-font-semibold" style="font-size: 1rem !important;">Send only at specified local time?</div>
                        </TSwitch>
                    </div>
                    <div v-if="local_time" class="tw-pl-4">
                        <div class="tw-flex">
                            <TField label="User's local time">
                                <TTimePicker
                                    v-model="time_in_local_time"
                                >
                                </TTimePicker>
                            </TField>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="tw-flex">
                        <TSwitch v-model="use_offset">
                            <div class="tw-mr-2 tw-font-semibold" style="font-size: 1rem !important;">Delayed send?</div>
                        </TSwitch>
                    </div>
                    <div v-if="use_offset" class="tw-pl-4">
                        <i>After we determine we want to send a user an email, wait this much time before sending.</i>
                        <div class="tw-flex">
                            <TField label="Time to delay (HH:MM)">
                                <TInput
                                    type="number"
                                    class="tw-w-16"
                                    min="0"
                                    max="23"
                                    v-model="offset_hours">
                                </TInput>
                                <span class="mx-1"> : </span>
                                <TInput
                                    class="tw-w-16"
                                    type="number"
                                    min="0"
                                    max="59"
                                    v-model="offset_minutes">
                                </TInput>
                            </TField>
                        </div>
                    </div>
                </div>
                <div v-if="send_type == 'Event'" class="tw-mb-2 tw-flex tw-items-start">
                    <TSwitch size="small" v-model="apply_filter">
                        <div class="tw-mr-2 tw-font-semibold" style="font-size: 1rem !important;">Filter users?</div>
                    </TSwitch>
                </div>
                <div v-if="filterRequired" 
                    :class="{'tw-px-4': send_type === 'Event', 'tw-px-2': send_type !== 'Event'}"
                    class="tw-mt-2 tw-is-flex tw-items-end">
                    <TField label="Users">
                        <template #label>
                            <div class="tw-mb-2 tw-block tw-text-left tw-font-semibold">
                                <span>Users</span>
                                <span 
                                    v-if="!commPreview.loading"
                                    title="Estimated # of users" class="tw-ml-2 mdi mdi-account-group">
                                    <span v-if="!commPreview.loading" class="tw-ml-1 tw-text-sm">{{commPreview.total}}</span>
                                </span>
                                <span v-else title="Calculating segment size" class="tw-ml-2 mdi mdi-loading mdi-spin"></span>
                            </div>
                        </template>
                        <TButton 
                            class="tw-mb-0 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                            @click="displayRuleModal(filter)"
                            v-if="!filter">Select recipients
                        </TButton>
                        <RulePreview
                            class="tw-cursor-pointer"
                            @click="displayRuleModal(filter)"
                            :value="filter">
                        </RulePreview>
                    </TField>
                </div>
                <div class="tw-px-2">
                    <EmailContent 
                        v-if="comm_type == 'email'"
                        v-model:contenterror="emailContentError"
                        :campaign_id="campaign_id"
                        :comm_id="comm_id"
                        :comm="json"
                        @save="saveContent"
                        :content="makeCopy(content)">
                    </EmailContent>
                    <InAppContent 
                        v-else
                        :comm="json"
                        v-model:contenterror="inappContentError"
                        @save="saveContent"
                        :content="makeCopy(content)">
                    </InAppContent>
                </div>
                <div class="tw-p-4 tw-flex tw-justify-end tw-items-center">
                    <TButton :disabled="canSave" @click="save" class="tw-mr-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500">Save</TButton>
                    <TButton @click="goBack" class="tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white">Cancel</TButton>
                </div>
            </div>
            <TModal 
                full-screen
                v-model="showRuleModal">
                <div>
                    <p class="tw-text-3xl tw-mb-2">
                        Who do you want to send this {{comm_type == 'email' ? "email" : "in-app message"}} to?
                    </p>
                    <div class="tw-p-2">
                        <p class="tw-mb-2 tw-flex tw-justify-between">
                            <small>
                                Here are some examples:
                                <a class='tw-ml-4 tw-text-blue-500 hover:tw-text-blue-900' 
                                    @click.prevent='editingRule = { op: "and", rules: [ { op: "==", "field": "location_country_iso:STRING:BatchAlways:_", value: "US" }, { op: "==", "field": "user_class:STRING:BatchAlways:_", value: "Dealer" } ] }'>US Dealers</a>
                                <a class='tw-ml-4 tw-text-blue-500 hover:tw-text-blue-900' 
                                    @click.prevent='editingRule = { op: "and", rules: [ { op: "!=", "field": "location_country_iso:STRING:BatchAlways:_", value: "US" }, { op: "!=", "field": "user_class:STRING:BatchAlways:_", value: "Normal" }, { op: "==", "field": "license_has_lifetime:BOOLEAN:BatchAlways:_", value: true } ] }'>non-US lifetimers</a>
                                <a class='tw-ml-4 tw-text-blue-500 hover:tw-text-blue-900' 
                                    @click.prevent='editingRule = { op: "and", rules: [ { op: "!=", "field": "location_country_iso:STRING:BatchAlways:_", value: "US" }, { op: "!=", "field": "user_class:STRING:BatchAlways:_", value: "Normal" }, { op: "==", "field": "os_has_roonos:BOOLEAN:BatchAlways:_", value: true } ] }'>US users not running Roon OS</a>
                            </small>
                            <span 
                                v-if="!editPreview.loading"
                                title="Estimated # of users" class="tw-ml-2 mdi mdi-account-group">
                                <span v-if="!editPreview.loading" class="tw-ml-1 tw-text-sm">{{editPreview.total}}</span>
                            </span>
                            <span v-else title="Calculating segment size" class="tw-ml-2 mdi mdi-loading mdi-spin"></span>
                        </p>
                        <RuleBuilder :store="store" v-model="editingRule"></RuleBuilder>
                        <div class="tw-p-4 tw-flex tw-justify-end tw-items-center">
                            <TButton 
                                class="tw-mr-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
                                @click="saveFilter()">Save</TButton>
                            <TButton 
                                class="tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white"
                                @click="showRuleModal = false">Cancel</TButton>
                        </div>
                    </div>
                </div>
            </TModal>
            <TModal v-model="cancelDialog.show">
                <div class="tw-px-2 tw-w-96">
                    <span class="tw-text-2xl mdi mdi-alert-circle tw-text-red-600">&nbsp;<span class="tw-text-black">You have unsaved changes</span></span>
                    <div class="tw-w-100 tw-break-normal tw-my-3 tw-mx-2">Are you sure you want to cancel? <b>Your changes will be discarded, and cannot be fully restored.</b></div>
                    <div class="tw-mt-6 tw-flex tw-justify-end">
                        <TButton
                            class="tw-w-32 tw-mr-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
                            @click="cancelDialog.confirmCb"
                        >Yes</TButton>
                        <TButton
                            @click="cancelDialog.show = false"
                            class="tw-w-32 tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white"
                        >No</TButton>
                    </div>
                </div>
            </TModal>
        </div>
    </div>
</template>
<style lang="scss">
.preview-modal {
    > .animation-content {
        max-height: none !important;
        min-height: 100% !important;
    }
}
.preview-tabs {
    .tab-content {
        flex: 1;
        padding: 0px 1rem !important;
        .tab-item {
            height: 100%;
            overflow: auto;
        }
    }
}

@media only screen and (max-width: 769px) {
    .content-container {
        width: 100%;
    }
}

</style>
<script>
import { useToast }             from 'vue-toastification';
import { store }                from '@/core/store';
import RuleBuilder              from '@/components/RuleBuilder.vue';
import RulePreview              from '@/components/RulePreview.vue';
import EmailContent             from '@/components/EmailContent.vue';
import InAppContent             from '@/components/InAppContent.vue';
import TDropdown                from '@/components/TDropdown.vue';
import { UndoHtmlReplaceLinks, UndoReplaceLink } from '@/core/links';
import axios                    from 'axios'

import { deepEqual } from '@/core/utils';
import {
    TSwitch,
    TField,
    TInput,
    TButton,
    TSimplePicker,
    TDatetime,
    TTimePicker,
    TModal
} from '@roonlabs/vue-tailwind'

export default {
    name: 'EditComm',
    components: { TDropdown, TModal, TDatetime, TTimePicker, TSimplePicker, TSwitch, TField, TInput, TButton, InAppContent, EmailContent, RulePreview, RuleBuilder },
    props: {
        campaign_id: {
            type:     String,
            required: true
        },
        comm_id: String
    },
    data() {
        return {
            initialized:          false,
            lskey:                null,
            use_offset:           false,
            local_time:           false,
            scheduled:            false,
            variable_substitution: false,
            loading:              true,
            name:                 '',
            category:             'company_news',
            max_sends:            'once',
            comm_type:            'email',
            enabled:              false,
            is_dev:               false,
            start_date:           null,
            end_date:             null,
            send_type:            'OneShot',
            time_in_local_time:   null,
            offset_hours:         0,
            offset_minutes:       0,
            apply_filter:         false,
            filter:               null,
            editingRule:          null,
            showRuleModal:        false,
            content: {
                emails:  [],
                message: null 
            },

            copy: '',

            cancelDialog: {
                show: false,
                confirmCb: null
            },

            commPreview: {
                total: 0,
                users: [],
                loading: false,
                key: 0
            },
            editPreview: {
                total: 0,
                users: [],
                loading: true,
                key: 0
            },
            emailContentError: false,
            inappContentError: false,
            oldChanges: {
                show: false,
                cb: null
            }
        }
    },
    watch: {
        'filterKey': {
            deep:      true,
            immediate: true,
            handler(newvalkey, oldvalkey) {
                if (newvalkey && newvalkey != 'null' && newvalkey != oldvalkey) {
                    if (this.canSaveFilter(JSON.parse(newvalkey), false))
                        this.getPreview(JSON.parse(newvalkey), ++this.commPreview.key, this.commPreview);
                }
            }
        },
        'editingRuleKey': {
            deep:      true,
            immediate: true,
            handler(newvalkey, oldvalkey) {
                if (newvalkey && newvalkey != 'null' && newvalkey != oldvalkey) {
                    if (this.canSaveFilter(JSON.parse(newvalkey), false))
                        this.getPreview(JSON.parse(newvalkey), ++this.editPreview.key, this.editPreview);
                }
            }
        },
        'apply_filter': {
            handler(newval, oldval) {
                // Use editing rule as a cache when toggling the apply switch
                if (newval) {
                    if (this.editingRule) this.filter = JSON.parse(JSON.stringify(this.editingRule));
                } else {
                    if (this.filter) this.editingRule = JSON.parse(JSON.stringify(this.filter));
                    this.filter = null;
                }
            }
        },
        json() {
            if (this.initialized) {
                localStorage.setItem(this.lskey, JSON.stringify(this.json));
            }
        }
    },
    methods: {

        async getPreview(filter, key, preview) {
            await new Promise(r => setTimeout(async () => {
                if (preview.key === key) {
                    preview.loading = true;
                    try {
                        const res = await axios.post('/api/1/comms/' +  this.comm_id + '/preview', { filter, category: this.category });
                        if (preview.key === key) {
                            const { total, users }  = res.data;
                            preview.total      = total;
                            preview.users      = users;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                    preview.loading = false;
                }
                r();
            }, 500))
        },

        displayRuleModal(filter) {
            this.editingRule   = JSON.parse(JSON.stringify(filter));
            this.showRuleModal = true;
        },

        canSaveFilter(r, popup = true) {
            if (!r)
                return false;
            if (r.rules !== undefined) {
                let i = r.rules.length;
                for (let rule of r.rules) {
                    if (!this.canSaveFilter(rule, popup)) {
                        return false;
                    }
                }
                return true;

            } else {
                if (!r.field) {
                    if (popup)
                        this.toast.error(`One of your conditions is incomplete.`);
                    return false;
                }
                return true;
            }
        },
        saveFilter() {
            if (!this.canSaveFilter(this.editingRule))
                return;

            this.filter = this.editingRule;
            this.showRuleModal = false;
        },

        goBack() {
            if (this.unsavedChanges) {
                this.cancelDialog.show = true
                this.cancelDialog.confirmCb = () => {
                    delete localStorage[this.lskey]
                    this.$router.replace({name: 'Campaign', param: { campaign_id: this.campaign_id }});
                }
            } else {
                delete localStorage[this.campaign_id + '-' + (this.comm_id || 'new')]
                this.$router.replace({name: 'Campaign', param: { campaign_id: this.campaign_id }});
            }
        },
        defaultEmail() {
            return {}
        },


        // Used to compare database comm to local storage comm
        comm_to_ui(comm) {
            const copy = JSON.parse(JSON.stringify(comm));
            return {
                comm_id            : copy.comm_id,
                name               : copy.name,
                category           : copy.category,
                max_sends          : copy.max_sends,
                comm_type          : copy.comm_type,
                enabled            : copy.enabled,
                is_dev             : copy.is_dev,
                variable_substitution: copy.variable_substitution,
                start_date         : copy.start_date,
                end_date           : copy.end_date  ,
                send_type          : copy.send_type,
                time_in_local_time : copy.time_in_local_time,
                offset             : copy.offset,
                filter             : copy.filter || null, // First rule is always system supplied DNC based on comm category
                content            : copy.content,
            }
        },


        mapComm(comm, og) {
            // This is all we need
            this.name               = comm.name;
            this.category           = comm.category;
            this.max_sends          = comm.max_sends;
            this.comm_type          = comm.comm_type;
            this.enabled            = comm.enabled;
            this.is_dev             = comm.is_dev;
            this.variable_substitution = comm.variable_substitution;
            this.start_date         = comm.start_date;
            this.end_date           = comm.end_date  ;
            this.send_type          = comm.send_type;
            this.time_in_local_time = comm.time_in_local_time || null;
            this.offset_hours       = comm.offset ? (comm.offset - (comm.offset % ( 60 * 60 ))) / (60*60) : null;
            this.offset_minutes     = comm.offset ? (comm.offset % ( 60 * 60 )) / 60 : null;
            this.filter             = comm.filter || null; // First rule is always system supplied DNC based on comm category
            this.content            = comm.content;

            // Set toggle switch states
            if (this.offset_hours || this.offset_minutes) {
                this.use_offset = true;
            }

            if (this.time_in_local_time) {
                this.local_time = true;
            }

            if (this.start_date || this.end_date) {
                this.scheduled = true;
            }

            // IF comm has a filter
            if (this.filter) {
                this.apply_filter = true;
            }

            // Takes snapshot of computed everything object
            this.snapshot(og ? this.comm_to_ui(og) : null);
            this.initialized = true;
        },

        snapshot(og) {
            // Pass og if you want to snapshot a different version
            this.copy = JSON.stringify(og || this.json)
        },

        async save() {
            this.loading = true;
            try {
                let res;
                if ( this.comm_id ) {
                    res = await axios.put('/api/1/comms/' + this.campaign_id + '/' + this.comm_id, this.json);
                } else {
                    res = await axios.post('/api/1/comms/' + this.campaign_id, this.json);
                }
                const { comm } = res.data;
                delete localStorage[this.lskey]
                this.$router.replace({ name: 'Campaign', params: { campaign_id: this.campaign_id }})
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },

        saveContent(content) {
            Object.assign(this.content, content)
        },
        makeCopy(content) {
            return JSON.parse(JSON.stringify(content));
        },
        foundOldRestore() {
            this.oldChanges.cb();
        },
        foundOldRevert() {
            delete(localStorage[this.lskey]);
            this.oldChanges.cb();
        },
        async load() {
            this.lskey = this.campaign_id + '-' + this.comm_id;
            if ( this.comm_id ) {
                try {
                    const res = await axios.get('/api/1/comms/' + this.comm_id);
                    const { comm } = res.data;

                    // DNC added in server side
                    comm.filter = comm.filter?.rules[1];

                    if (localStorage[this.lskey]) {
                        if (!deepEqual(JSON.parse(localStorage[this.lskey]), this.comm_to_ui(comm))) {
                            this.oldChanges.show = true;
                            this.loading = false;
                            await new Promise(r => { this.oldChanges.cb = r });
                            this.oldChanges.show = false;
                        } else {
                            delete localStorage[this.lskey];
                        }
                        if (localStorage[this.lskey]) {
                            try {
                                this.mapComm(JSON.parse(localStorage[this.lskey]), comm);
                            } catch (e) {
                                console.log(e);
                                delete localStorage[this.lskey];
                                this.mapComm(comm);
                            }
                        } else {
                            this.mapComm(comm);
                        }
                    } else {
                        this.mapComm(comm);
                    }

                } catch (e) {
                    // XXX Should display an error here.
                    console.log(e);
                }
            } else {
                this.snapshot();
                if (localStorage[this.lskey]) {
                    this.oldChanges.show = true;
                    this.loading = false;
                    await new Promise(r => { this.oldChanges.cb = r });
                    this.oldChanges.show = false;
                    if (localStorage[this.lskey]) {
                        try {
                            this.mapComm(JSON.parse(localStorage[this.lskey]), this.copy);
                        } catch (e) {
                            console.log(e);
                            delete localStorage[this.lskey];
                        }
                    }
                }
                this.initialized = true;
            }
            this.loading = false;
        }
    },


    computed: {
        variable_substitution_string() {
            return this.variable_substitution ? 'Disable {{variable}} substitution?' : 'Enable {{variable}} substitution?'
        },
        contentError() {
            if (this.comm_type === 'email' && this.emailContentError) return true;
            if (this.comm_type === 'in-app' && this.inappContentError) return true;
            return false;
        },
        filterRequired() {
            return this.send_type != 'Event' || this.apply_filter
        },
        editingRuleKey() {
            return JSON.stringify(this.editingRule)
        },
        filterKey() {
            return JSON.stringify(this.filter)
        },
        store() {
            return store
        },

        canSave() {
            if (this.enabled && (this.send_type === 'OneShot' || this.send_type === 'OnGoing') && !this.filter) return true;
            return this.contentError || !this.unsavedChanges || !this.name || (this.comm_type === 'email' && !this.content?.emails[0]?.id) || (this.comm_type == 'in-app' && !this.content.message)
        },


        _start_date() {
            if (this.scheduled) return this.start_date
            return null
        },
        _end_date() {
            if (this.scheduled) return this.end_date
            return null
        },
        _time_in_local_time() {
            if (this.local_time) return this.time_in_local_time
            return null
        },
        _offset_hours() {
            if (this.use_offset) return this.offset_hours
            return null
        },
        _offset_minutes() {
            if (this.use_offset) return this.offset_minutes
            return null
        },
        _filter() {
            if (this.filterRequired || this.apply_filter) return this.filter
            return null
        },

        json() {
            // Clear out junk
            const content = JSON.parse(JSON.stringify(this.content));
            if ( this.comm_type === 'email' ) {
                content.message= null;
            } else {
                content.emails = [];
            }
            return {
                ...(this.comm_id && {comm_id: this.comm_id}),
                send_type          : this.send_type,
                name               : this.name,
                category           : this.category,
                max_sends          : this.max_sends,
                comm_type          : this.comm_type,
                enabled            : this.enabled,
                is_dev             : this.is_dev,
                variable_substitution: this.variable_substitution,
                start_date         : this._start_date,
                start_date:          this._start_date         ? this._start_date.slice(0,-1) : null,
                end_date:            this._end_date           ? this._end_date.slice(0,-1)   : null,
                time_in_local_time : this._time_in_local_time,
                offset:              this.use_offset ? this._offset_hours * 60 * 60 + this._offset_minutes * 60 : null,
                filter             : this._filter,
                content            : this.content,
            }
        },

        unsavedChanges() {
            return !deepEqual(JSON.parse(this.copy || '{}'), this.json)
        },
    },

    setup() {
        return { toast: useToast() }
    },

    created() {
        this.load();
    }


}
</script>
